import axiosInstance from '@/api/axiosInstance';
import { UpdateQuizPayload, UpdateQuizResponse } from './types';

/**
 * Update an existing quiz
 * PUT /api/learning-center/quizzes/:id
 * Requires ROLE_LEARNING_ADMIN or ROLE_SUPER_ADMIN
 */
export const updateQuiz = async (
  id: number,
  payload: UpdateQuizPayload
): Promise<UpdateQuizResponse> => {
  try {
    const response = await axiosInstance.put<UpdateQuizResponse>(
      `/api/learning-center/quizzes/${id}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error(`Error updating quiz ${id}:`, error);
    throw error;
  }
};
